import React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbIcon as ClbIcon_ } from '@celebration/design-system/dist/lib/icon';
export const ClbIcon = createComponent({
    tagName: ClbIcon_.tagName,
    elementClass: ClbIcon_,
    react: React,
    events: {},
});
//# sourceMappingURL=index.js.map